import React from 'react';
import styled from 'styled-components';
import { IconProps, palette } from '@landr/maestro';

export interface IconArtworkProps {
    icon: React.ComponentType<IconProps>;
}

const IconWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 18%;
    background-color: ${palette('neutral.800')};

    svg {
        vertical-align: middle;
        min-width: 100%;
        min-height: 100%;

        color: ${palette('neutral.400')};

        > path,
        circle {
            stroke-width: 1%;
        }

        g {
            path,
            circle {
                stroke-width: 1%;
            }
        }
    }
`;

const IconArtwork: React.FC<IconArtworkProps> = ({ icon: Icon }) => {
    return (
        <IconWrapper>
            <Icon />
        </IconWrapper>
    );
};

IconArtwork.displayName = 'IconArtwork';

export default IconArtwork;
